/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamCompanyDropdownQueryResponse,
  GetApiV1ExamCompanyDropdownQueryParams,
  GetApiV1ExamCompanyDropdown400,
  GetApiV1ExamCompanyDropdown401,
  GetApiV1ExamCompanyDropdown500,
} from "../../types/examSharedController/GetApiV1ExamCompanyDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamCompanyDropdown } from "../../clients/examSharedController/getApiV1ExamCompanyDropdown.ts";

export const getApiV1ExamCompanyDropdownQueryKey = (
  params?: GetApiV1ExamCompanyDropdownQueryParams,
) =>
  [
    { url: "/api/v1/exam/company-dropdown" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamCompanyDropdownQueryKey = ReturnType<
  typeof getApiV1ExamCompanyDropdownQueryKey
>;

export function getApiV1ExamCompanyDropdownQueryOptions(
  params?: GetApiV1ExamCompanyDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamCompanyDropdownQueryKey(params);
  return queryOptions<
    GetApiV1ExamCompanyDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCompanyDropdown400
      | GetApiV1ExamCompanyDropdown401
      | GetApiV1ExamCompanyDropdown500
    >,
    GetApiV1ExamCompanyDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamCompanyDropdown(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de empresas para uso em componentes de seleção. Quando informado o courseId, retorna apenas as empresas associadas ao curso; caso contrário, retorna todas as empresas ativas. **(Requer Authorization para autenticação)**
 * @summary Lista de empresas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/company-dropdown}
 */
export function useGetApiV1ExamCompanyDropdown<
  TData = GetApiV1ExamCompanyDropdownQueryResponse,
  TQueryData = GetApiV1ExamCompanyDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamCompanyDropdownQueryKey,
>(
  params?: GetApiV1ExamCompanyDropdownQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamCompanyDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamCompanyDropdown400
          | GetApiV1ExamCompanyDropdown401
          | GetApiV1ExamCompanyDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamCompanyDropdownQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamCompanyDropdownQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamCompanyDropdown400
      | GetApiV1ExamCompanyDropdown401
      | GetApiV1ExamCompanyDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
